export function getBottomPaddingClass(activeMenu) {
    const noBottomPaddingMenus = ["ai-assistant", "students", "teachers", "attendance", "dashboard"];
    return noBottomPaddingMenus.includes(activeMenu) ? "pb-0" : "pb-[90px]";
}

export function getMainPaddingTop(activeMenu) {
    return activeMenu === "ai-assistant" ? 0 : "max(env(safe-area-inset-top), 35px)";
}

export function getContentContainerClass(activeMenu) {
    const selfScrollMenus = ["ai-assistant", "students", "teachers", "attendance"];
    const dashboardMenus = ["dashboard"];
    const flatMenus = ["ai-assistant"];
    const edgeToEdgeMenus = ["attendance", "students", "teachers", "counseling"];

    const overflowClass = selfScrollMenus.includes(activeMenu)
        ? "overflow-hidden h-full md:overflow-y-auto md:h-auto"
        : "overflow-y-auto";

    let paddingClass = "px-0.5 pt-0 pb-4 md:p-4";
    if (dashboardMenus.includes(activeMenu)) {
        paddingClass = "px-0.5 pt-1 pb-0 md:p-4";
    } else if (flatMenus.includes(activeMenu)) {
        paddingClass = "p-0";
    } else if (edgeToEdgeMenus.includes(activeMenu)) {
        paddingClass = "p-0 md:pt-0 md:px-4 md:pb-4";
    }

    return `flex-1 custom-scrollbar mobile-hide-scrollbar ${overflowClass} ${paddingClass}`;
}
